<template>
<div class='milestore-warp' v-if="moduleData">
  <div class="milestore" :style="{backgroundImage :`url(${moduleData.bg})`}">
    <h3>{{moduleData.title}}</h3>
    <p>{{moduleData.subTitle}}</p>
  </div>
  <div class='milestore-images'>
    <div class='milestore-inner' :style="{backgroundImage :`url(${viewImage(moduleData.image, 1847, 365, 'png')})`}"></div>
    <div class='milestore-inner' :style="{backgroundImage :`url(${viewImage(moduleData.image, 1847, 365, 'png')})`}"></div>
  </div>
</div>
</template>
<script>
import { util } from '@utils' 
export default {
  data() {
    return {
      listData: []
    }
  },
  props: {
    moduleData: {
      type: Object,
      default: () => {}
    }
  },
  
  methods: {
    viewImage(value, width, height, type) {
      return util.viewImage(value, width, height, type)
    }
  }
}
</script>
<style lang="scss" scoped>
@keyframes rolling {
  0% { transform: translateX(0px); }
  100% { transform: translateX(-1832px); }
}

.milestore-warp{
  height: 500px;
  position: relative;
}
.milestore{
  width: 100%;
  height: 100%;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  z-index: 1;

  h3{
    text-align: center;
    color: #fff;
    font-size: 30px;
    padding-top: 72px;
    padding-bottom: 16px;
    line-height: 1;
  }

  p{
    color:#bbb;
    font-size:14px;
    text-align: center;
  }
}
.milestore-images{
  display: flex;
  position: absolute;
  width: 5000px;//3980px;
  height: 365px;
  bottom: -10px;
  z-index: 2;
}
.milestore-inner{
  width: 1832px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: 50%;
  background-repeat: no-repeat;
  animation: 30s rolling infinite linear;
}
</style>
